(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("@angular/common"), require("rxjs/add/operator/takeUntil"), require("rxjs/Subject"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "@angular/common", "rxjs/add/operator/takeUntil", "rxjs/Subject"], factory);
	else if(typeof exports === 'object')
		exports["angularTextInputAutocomplete"] = factory(require("@angular/core"), require("@angular/common"), require("rxjs/add/operator/takeUntil"), require("rxjs/Subject"));
	else
		root["angularTextInputAutocomplete"] = factory(root["ng"]["core"], root["ng"]["common"], root["Rx"], root["Rx"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition